import Cookies from 'js-cookie';
import { LocalStorageKeys } from 'appConstants/LocalStorageKeys';
import { HttpServiceVault } from 'services/Vault/client/types';
import VaultService from 'services/Vault/VaultService';
import { createHttpInstance, HttpRequestConfig } from 'services/httpClient';

const API_URL = import.meta.env.VITE_VAULT_URL;

export const instanceVault = createHttpInstance({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

instanceVault.interceptors.request.use((config: HttpRequestConfig) => {
  const token = Cookies.get(LocalStorageKeys.VAULT_TOKEN_KEY);
  if (token) {
    const headers = { ...(config.headers ?? {}) };
    headers.Authorization = `Bearer ${JSON.parse(token)}`;
    return { ...config, headers };
  }
  return config;
});

export const httpServiceVault: HttpServiceVault = {
  VaultService,
};
